export * from '@app/shared/components/dropzone/dropzone.component';
export * from '@app/shared/components/files/files.component';
export * from '@app/shared/components/fil-list/file-list.component';
export * from '@app/shared/components/btn-confirm/btn-confirm.component';
export * from '@app/shared/components/contact-search/contact-search.component';
export * from '@app/shared/components/contact-card/contact-card.component';
export * from '@app/shared/components/order-table/order-table.component';
